const handleAddImage = ({placeholderImage, storyboardState, setStoryboardState}) =>{
    const tempStoryboardState = {...storyboardState}
    tempStoryboardState.storyboard.push({image:placeholderImage, itemPrompt:'', selectedCharacter:'None', label:'', notes:'' })
    setStoryboardState(tempStoryboardState)
}
export default handleAddImage